import React, { Component } from 'react';
import { Route, Switch, Redirect, withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Drawer, ConfigProvider, Modal, Button } from 'antd';
import { serviceAdmin } from '../config';

import Login from './login/Login';
import LoginCard from './login/LoginCard';
import Audience from './audience/Audience';

/* Components */
import SideNav from './sidenav/SideNav';
import TopNav from './topnav/TopNav';

/* Other pages */
import NotFound from './otherpages/NotFound';


import './app.css';


import {
	userTimeout,
	userLogin
} from '../modules/user';

import {
	organizationList
} from '../modules/organization';
import Dashboard from './dashboard/Dashboard';
import UserManagement from './usermanagement/UserManagement';
import StreamManagement from './streammanagement/StreamManagement';
import ReplayManagement from './replaymanagement/ReplayManagement';
import FeatureManagement from './featuremanagement/FeatureManagement';

const ScrollToTopPage = () => {
	window.scrollTo(0, 0);
	return null;
};

class App extends Component {

	componentDidMount = async () => {
		const { userTheme, userNav } = this.props;
		localStorage.removeItem('apiKey');
		document.body.setAttribute("data-theme", 'light');
		document.body.setAttribute("data-width", userNav ? 'wide' : 'narrow');
		document.addEventListener(
			"SessionExpired",
			(e) => {
				this.props.userTimeout(true);
			},
			false
		);
		if (this.props.userAuthenticated) {
			this.props.organizationList();
		}
	}

	componentDidUpdate(prevProps) {
		const { userTheme, userNav } = this.props;
		document.body.setAttribute("data-theme", 'light');
		if (JSON.stringify(userNav) !== JSON.stringify(prevProps.userNav)) {
			document.body.setAttribute("data-width", this.props.userNav ? 'wide' : 'narrow');
		}
		if (this.props.userAuthenticated && !prevProps.userAuthenticated) {
			this.props.organizationList();
		}
	}


	render() {
		const { userProfile, userSessionTimeout } = this.props;
		var userRole = (userProfile.user) ? userProfile.user.role : null;
		var rootUrl = "/";
		var auth_token;

		let params = new URL(document.location.toString()).searchParams;
		if (params.get("auth_token")) {
			auth_token = params.get("auth_token");
		}

		const PrivateRoute = ({ component: Component, isAuthenticated, typeAccount, path, ...rest }) => {
			return <Route
				{...rest}
				render={props => ((isAuthenticated || userSessionTimeout) ?
					<Component {...props} />
					:
					(<Redirect to="/login" />)
				)}
			/>
		};

		var classMainContent = 'mainContent';
		if (['/marketplace'].includes(this.props.router.location.pathname)) {
			classMainContent += ' full';
		}
		return (
			<ConfigProvider
				theme={{
					token: {
						fontFamily: 'Montserrat, sans-serif',
					},
				}}
			>
				<div className="App">
					{
						((!['/login'].includes(this.props.router.location.pathname)) && !auth_token) ?
							<div>
								<TopNav SelectChannel={this.SelectChannel} />
								<SideNav />
								{
									!(window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') ?
										<Modal
											title="Session Expired"
											open={userSessionTimeout}
											closable={false}
											footer={[
												<Button
													key="login"
													type="primary"
													onClick={() => window.location.href = `${serviceAdmin}?action=logout`}
												>
													Return to Login
												</Button>
											]}
										>
											<p>Your session has expired. Please return to the home page to log in again.</p>
										</Modal>
										:
										<Drawer
											title="Session Expired"
											placement={`right`}
											closable={false}
											open={userSessionTimeout}
											key={`right`}
										>
											<span>Your session has expired. Please log in again to continue.</span>
											<LoginCard userSessionTimeout={true} />
										</Drawer>
								}
							</div>
							:
							""
					}

					<Switch>
						<Route component={ScrollToTopPage} />
					</Switch>
					{auth_token ?
						<Route path="*" component={Login} /> :
						<div className={classMainContent} >
							<Switch>
								<Route path="/login" component={Login} />
								{this.props.userAuthenticated ? <Redirect exact from="/" to="/user-management" /> : <Redirect exact from="/" to="/login" />}
								<PrivateRoute exact path="/dashboard" component={Dashboard} isAuthenticated={this.props.userAuthenticated} typeAccount={['admin', 'editor', 'viewer']} />
								<PrivateRoute exact path="/user-management" component={UserManagement} isAuthenticated={this.props.userAuthenticated} typeAccount={['admin', 'editor', 'viewer']} />
								<PrivateRoute exact path="/stream-management" component={StreamManagement} isAuthenticated={this.props.userAuthenticated} typeAccount={['admin', 'editor', 'viewer']} />
								<PrivateRoute exact path="/replay-management" component={ReplayManagement} isAuthenticated={this.props.userAuthenticated} typeAccount={['admin', 'editor', 'viewer']} />
								<PrivateRoute exact path="/feature-management" component={FeatureManagement} isAuthenticated={this.props.userAuthenticated} typeAccount={['admin', 'editor', 'viewer']} />
								<Route path="*" exact component={NotFound} />
							</Switch>
						</div>
					}

				</div>
			</ConfigProvider>
		);
	}
}


const mapStateToProps = state => ({
	router: state.router,
	userAuthenticated: state.user.userAuthenticated,
	userSessionTimeout: state.user.userSessionTimeout,
	userProfile: state.user.userProfile,
	userTheme: state.user.userTheme,
	userNav: state.user.userNav
});

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			userTimeout,
			userLogin,
			organizationList,
		},
		dispatch
	);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));
